



import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class DataLayer extends Vue {
    @Prop()
    public script!: string;

    @Prop()
    public usecookie!: boolean;

    private dataLayer = (window as any).dataLayer || [];


    constructor() {
        super();
        if(this.script) {
            this.dataLayer.push(JSON.parse(this.script));
            if(this.usecookie){
                const urlSearchParams = new URLSearchParams(window.location.search);
                let orderId = urlSearchParams.get("orderId");
                const cookieValue = this.getCookie("OrderConfirmationShowed");
                var now = new Date();
                now.setDate(now.getDate() + 30);                
                const values = cookieValue.split(',');
                if(cookieValue){
                    if(orderId != null && !values.includes(orderId)){
                        orderId = `${cookieValue},${orderId}`
                        document.cookie = `OrderConfirmationShowed=${orderId};expires=${now.toUTCString()}`;
                    }
                }
                else {
                    document.cookie = `OrderConfirmationShowed=${orderId};expires=${now.toUTCString()}`;
                }
            }
        }
    }

    protected getCookie(cname: string)  {
        let name = cname + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        for(let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }
}
